export const SKELETON_COUNT = {
  NOTIFICATIONS: 5,
  PENDING_REQUESTS_INITIAL: 3,
  PENDING_REQUESTS_LOADING: 2,
} as const;
